import { createStore, compose as origCompose, combineReducers } from 'redux';
import { lazyReducerEnhancer } from 'pwa-helpers/lazy-reducer-enhancer.js';
import { connectRouter, navigate } from 'lit-redux-router';
import { DebugService } from '@services/debug.service';
import { REFI_LIENHOLDER_CONST } from './shared/constants/app.constants';

// @ts-expect-error TS(2339): Property '__REDUX_DEVTOOLS_EXTENSION_COMPOSE__' do... Remove this comment to see the full error message
const compose = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || origCompose;
const router = createStore(
  (state) => state,
  compose(lazyReducerEnhancer(combineReducers))
);

class _Router {
  base: string;
  debug: DebugService;
  rootElement: HTMLElement;
  constructor() {
    // @ts-expect-error TS(2345): Argument of type 'Store<unknown, Action<any>>' is ... Remove this comment to see the full error message
    connectRouter(router);
    this.debug = new DebugService('AppRouter');
    // @ts-expect-error TS(2531): Object is possibly 'null'.
    this.base = document.querySelector('base')
      ? document.querySelector('base')?.getAttribute('href')
      : '';
    this.rootElement = document.querySelector('refi-lienholder-app')!;
  }

  goTo(nav: string) {
    this.debug.log('goTo called with', nav);
    router.dispatch(navigate(`/#/lienholder/${nav}`));
    this.rootElement.dispatchEvent(REFI_LIENHOLDER_CONST.ROUTE_CHANGE_EVENT);
  }

  sendStateChangedEvent() {
    this.debug.log('Sending state-changed event to host app');
    const ev = new CustomEvent('host-app-event', {
      bubbles: true,
      composed: true,
      detail: {
        actionName: 'state-changed',
        from: 'lienholder-mfe',
        data: {
          state: 'lender-info',
        },
      },
    });
    this.rootElement.dispatchEvent(ev);
  }

  sendNextMFEEvent() {
    this.debug.log('Sending next-mfe event to host app');
    const ev = new CustomEvent('host-app-event', {
      bubbles: true,
      composed: true,
      detail: {
        actionName: 'next-mfe',
        data: {},
      },
    });
    this.rootElement.dispatchEvent(ev);
  }
}

export const Router = new _Router();
